// Copyright (c) 2017 Deere & Company

import actions from '../actions-list';

export const resetCustomer = () => ({
    type: actions.RESET_PRODUCTS_BY_CUSTOMER_SEARCH_CUSTOMER
});



// WEBPACK FOOTER //
// ./src/product/products-by-customer/action-creators/reset-customer.js